import angular from 'angular';

angular.module('fg').directive('fgSubfieldVisibility', function () {
  return {
    restrict: 'E',
    templateUrl:
      'angular-form-gen/edit/canvas/field/subfield-visibility/subfield-visibility.ng.html',
    scope: {
      field: '=',
      title: '@',
      helpText: '@',
      fields: '='
    },
    link: function ($scope) {
      // Set defaults
      $scope.title = $scope.title || 'Sub Field Visibility';
      $scope.helpText =
        $scope.helpText ||
        'Allows you to show or hide a sub-field from end users during form submission. Hidden sub-fields still capture lookup data and appear in the step history.';
    }
  };
});
